import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PROJECT_DISCUSSION_COMMENT_CONTENT_TYPE_NEED_MORE_INFO } from '@shared/components/project-discussion/service/project-discussion.service.constants';
import { IProjectDiscussionGetCommentsResponse } from '@shared/components/project-discussion/service/project-discussion.service.types';
import { IProject } from '@shared/services/project.service.types';
import { ProjectDiscussionChatHeaderComponent } from '../project-discussion-chat-header/project-discussion-chat-header.component';
import { ProjectDiscussionChatControlsComponent } from '../project-discussion-chat-controls/project-discussion-chat-controls.component';
import { ProjectDiscussionChatRepliesComponent } from '../project-discussion-chat-replies/project-discussion-chat-replies.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-project-discussion-chat',
  templateUrl: './project-discussion-chat.component.html',
  styleUrls: ['./project-discussion-chat.component.scss'],
  imports: [CommonModule, ProjectDiscussionChatHeaderComponent, ProjectDiscussionChatControlsComponent,
    ProjectDiscussionChatRepliesComponent, TranslateModule ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectDiscussionChatComponent {
  @Input() comments: IProjectDiscussionGetCommentsResponse;
  @Input() project: IProject;

  readonly projectDiscussionCommentContentTypeNeedMoreInfo = PROJECT_DISCUSSION_COMMENT_CONTENT_TYPE_NEED_MORE_INFO;
}
